import React, {
    useEffect,
    useState
} from "react";


import {
    Modal,
    Form,
    Select,
    Button,
    Typography,
    Divider,
    Space,
    Spin,
    Descriptions,
    Input
} from "antd";


import {
    ArrowUpOutlined,
    CalendarOutlined,
    BookOutlined,
    CheckCircleOutlined
} from "@ant-design/icons";


import {
    motion
} from "framer-motion";


import Swal from "sweetalert2";


import api from "../../api/api";



const {
    Title,
    Text
} = Typography;


const {
    Option
} = Select;






const PromotionStudentRecord = ({
    open,
    onClose,
    student,
    refresh
}) => {



const [
    form
] = Form.useForm();





const [
    academicYears,
    setAcademicYears
]=useState([]);




const [
    gradeClasses,
    setGradeClasses
]=useState([]);




const [
    loading,
    setLoading
]=useState(false);




const [
    submitting,
    setSubmitting
]=useState(false);









const fetchPromotionData = async()=>{


try{


setLoading(true);



const [
    years,
    grades
]=await Promise.all([


api.get(
"/academic-years/"
),


api.get(
"/api/users/grade-classes/"
)


]);




/*
    All available future years only.
    No current academic year logic.
*/


setAcademicYears(
years.data || []
);



setGradeClasses(
grades.data || []
);



}
catch(error){


console.log(error);



Swal.fire({

icon:"error",

title:"Error",

text:
"Unable to load promotion options."

});


}
finally{


setLoading(false);


}



};









useEffect(()=>{


if(open){


form.resetFields();


fetchPromotionData();


}



},[
open,
student
]);









const handleSubmit = async(values)=>{


if(!student?.user_id){


Swal.fire({

icon:"warning",

title:"Student Missing",

text:
"Student information is unavailable."

});


return;


}







const confirm =
await Swal.fire({


title:
"Promote Student?",


text:
`Move ${student.full_name} to the selected class?`,


icon:"question",


showCancelButton:true,


confirmButtonText:
"Yes, Promote",


cancelButtonText:
"Cancel"



});






if(!confirm.isConfirmed)
return;









try{


setSubmitting(true);



const payload={


student_id:
student.user_id,


next_academic_year:
values.next_academic_year,


next_grade_class:
values.next_grade_class,


remarks:
values.remarks || ""


};







const response =
await api.post(

"/student-promote/",

payload

);







await Swal.fire({

icon:"success",

title:
"Promotion Successful",

text:
response.data.message ||
"Student promoted successfully."

});







form.resetFields();


onClose();



if(refresh){

refresh(
student.user_id
);

}



}
catch(error){


console.log(error);



Swal.fire({

icon:"error",

title:
"Promotion Failed",

text:
error.response?.data?.message ||
"Unable to promote student."

});


}
finally{


setSubmitting(false);


}



};









return (



<Modal


open={open}


onCancel={onClose}


footer={null}


centered


width={650}


destroyOnClose


maskClosable={false}



>



<motion.div


initial={{

opacity:0,

scale:.85,

y:40

}}


animate={{

opacity:1,

scale:1,

y:0

}}


transition={{

duration:.35

}}



>



<Space


direction="vertical"


size={20}


style={{

width:"100%"

}}



>




<div

style={{

textAlign:"center"

}}

>


<ArrowUpOutlined


style={{

fontSize:50,

color:"#1677ff"

}}


/>



<Title level={3}>

Promote Student

</Title>



<Text type="secondary">

Move student to the next academic level.

</Text>



</div>








{

loading ?


<div

style={{

textAlign:"center",

padding:40

}}

>

<Spin size="large"/>


</div>



:



<>





{

student &&

<Descriptions

bordered

column={1}

size="small"

>


<Descriptions.Item label="Student">

{student.full_name}

</Descriptions.Item>



<Descriptions.Item label="Current Class">

{
student.grade_class_name || "-"
}

</Descriptions.Item>



<Descriptions.Item label="Division">

{
student.division_assigned_name || "-"
}

</Descriptions.Item>


</Descriptions>


}






<Divider/>






<Form


layout="vertical"


form={form}


onFinish={handleSubmit}



>



<Form.Item
    label="Next Academic Year"
    name="next_academic_year"
    rules={[
        {
            required:true,
            message:"Select academic year"
        }
    ]}
>

<Select
    size="large"
    placeholder="Search Academic Year"
    showSearch
    allowClear
    suffixIcon={<CalendarOutlined/>}

    filterOption={(input, option)=>
        option.children
        .toLowerCase()
        .includes(input.toLowerCase())
    }

    dropdownStyle={{
        maxHeight:180,
        overflowY:"auto"
    }}

>

{
academicYears.map(year=>(

<Option
    key={year.id}
    value={year.id}
>
    {year.name}
</Option>

))
}

</Select>

</Form.Item>


<Form.Item
    label="Next Grade"
    name="next_grade_class"
    rules={[
        {
            required:true,
            message:"Select next grade"
        }
    ]}
>

<Select
    size="large"
    placeholder="Search Grade"
    showSearch
    allowClear
    suffixIcon={<BookOutlined/>}

    filterOption={(input, option)=>
        option.children
        .toLowerCase()
        .includes(input.toLowerCase())
    }


    dropdownStyle={{
        maxHeight:180,
        overflowY:"auto"
    }}

>

{
gradeClasses.map(grade=>(

<Option
    key={grade.id}
    value={grade.id}
>
    {grade.name}
</Option>

))
}

</Select>

</Form.Item>








<Form.Item


label="Remarks"


name="remarks"



>


<Input.TextArea


rows={3}


placeholder="Optional remarks"



/>



</Form.Item>








<Button


type="primary"


htmlType="submit"


block


size="large"


loading={submitting}


icon={
<CheckCircleOutlined/>
}


>


Promote Student


</Button>





</Form>





</>


}





</Space>



</motion.div>



</Modal>


);


};




export default PromotionStudentRecord;

